define.alias("ember-cli-string-helpers/helpers/camelize", "media/helpers/camelize");